import _ from "lodash"
import { JsonPlaceholderReplacer } from "json-placeholder-replacer"

const dataSelector = ({objectData,variables,path}) => {

  try {

  // Get the value in our object that matches our path
  const valueOrReference = _.cloneDeep(_.get(objectData,path))

  // This could be a fixed value or a reference to something in our instance data, or a combination / multiple references
  // This next call will resolve any references that are present.
  const placeHolderReplacer = new JsonPlaceholderReplacer()
  placeHolderReplacer.addVariableMap(variables)

  // We have to pass in an object, not a string, so we use "item"
  const pass1 = placeHolderReplacer.replace({item:valueOrReference})
  const ref = pass1.item
  const result = placeHolderReplacer.replace(pass1)

  // Now we have a value with all references resolved
  return {value:result.item, ref}
  }
  catch(err) {
    throw err
  }
}

export default dataSelector